import theme from "components/utils/theme";

export const cancelButtonDetails = {
    color: theme.palette.background.default,
    bgColor: theme.palette.error.main,
    hover: theme.palette.error.light,
    label: "Cancel Membership"
}